export const GreaterThanIcon = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 13.5L10.5 8.5L5.5 3.5"
      stroke="#115C36"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>
);
